import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default configuration options for the Order Payment Form component.
 */
export const defaultOrderPaymentFormConfig = {
    redirectReturnUrl: undefined,
    redirectPaymentMethods: {
        showIcons: true,
        showNames: false
    }
};
export const orderPaymentFormRedirectPaymentMethodsConfigValidator = Validator.object({
    showIcons: Validator.boolean(),
    showNames: Validator.boolean()
});
export const orderPaymentFormConfigValidator = Validator.object({
    redirectReturnUrl: Validator.optional(nonEmptyStringValidator),
    redirectPaymentMethods: orderPaymentFormRedirectPaymentMethodsConfigValidator
});
